<ng-container *ngFor="let change of changes | keyvalue">
    <ng-container *ngIf="hasAdded(change)" style="gap: 8px">
        <div *ngFor="let addedChannel of change.value" class="panel-container">
            <div class="panel-title-wrapper">
                <div class="panel-title">
                    {{ addedChannel }}
                </div>
            </div>
            <div class="change-container">
                {{ 'version-history.panel.mimic.added' | translate }}
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="hasDeleted(change)">
        <div *ngFor="let deletedChannel of change.value" class="panel-container">
            <div class="panel-title-wrapper">
                <div class="panel-title">
                    {{ deletedChannel }}
                </div>
            </div>
            <div class="change-container">
                {{ 'version-history.panel.mimic.deleted' | translate }}
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="hasUpdated(change)">
        <div *ngFor="let udpatedChannel of change.value | keyvalue" class="panel-container">
            <div class="panel-title-wrapper">
                <div class="panel-title">
                    {{ udpatedChannel.key }}
                </div>
            </div>
            <div *ngFor="let update of udpatedChannel.value.changes" class="change-container">
                {{ update.change }}
                <div class="change">
                    <div>"{{ update.old }}"</div>
                    <mat-icon svgIcon="arrow-right" class="arrow-icon" />
                    <div>"{{ update.new }}"</div>
                </div>
            </div>
        </div>
    </ng-container>
</ng-container>
